import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class Portal extends React.Component {
  componentDidMount() {
    const { selector } = this.props;
    this.element = document.querySelector(selector);
    this.forceUpdate();
  }

  render() {
    if (!this.element) {
      return null;
    }

    const { children } = this.props;

    return ReactDOM.createPortal(children, this.element);
  }
}

Portal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  selector: PropTypes.string.isRequired,
};

export default Portal;
